import React from 'react';

import SellerListingInsightStats from './SellerListingInsightStats';
import { Listing } from '@reverbdotcom/commons/src/gql/graphql';
import SellerListingCardInsightsActionMenu from './SellerListingCardInsightsActionMenu';
import { hasInsightRecommendation } from './insightHelpers';
import { LIVE, DRAFT } from './toolbarHelpers';
import { SELLER_SITE } from './listingActionMenuHelpers';

interface IExternalProps {
  listing: Listing;
}

interface IFooterProps extends IExternalProps {
  isMobile?: boolean;
}

export function isListingBumpEligible(listing: Listing) {
  const isListingLive = listing.state === LIVE;
  const isSellerSiteExclusive = listing.exclusiveChannel == SELLER_SITE;

  return isListingLive && !isSellerSiteExclusive;
}

export default function SellerListingCardFooter({ listing, isMobile = false }: IFooterProps) {

  // if listing state is draft, SellerListingInsightStats does not render
  const justifyClass = listing.state === DRAFT ? 'fx-justify-end' : 'fx-justify-between';

  return (
    <div className="seller-listing-card-footer">
      <div className={`d-flex ${justifyClass}`}>
        <SellerListingInsightStats listing={listing} />
        {isMobile && <SellerListingCardInsightsActionMenu listing={listing} hasRecommendation={hasInsightRecommendation(listing)} />}
      </div>
    </div>
  );
}
